import axios from 'axios';
import { attachAuth } from '@/utils/authSession';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

attachAuth(apiClient);

export default {
  /**
   * Fetch current user's profile, preferences, and entitlements
   * Endpoint: GET /api/me
   * 
   * Returns:
   * {
   *   user: {
   *     id: 4,
   *     username: "user1",
   *     email: "user@example.com"
   *   },
   *   entitlements: {
   *     tier: "FREE" | "CORE" | "PRO", // NOTE: "ELITE" tier exists in backend but not publicly available
   *     status: "NONE" | "ACTIVE" | "TRIALING" | "PAST_DUE" | "CANCELED" | "INCOMPLETE",
   *     isTrialing: false,
   *     trialEndsAt: null,
   *     currentPeriodEnd: null
   *   },
   *   preferences: {
   *     defaultBiasView: "mixed" | "left" | "right" | "center"
   *   }
   * }
   */
  fetchMe() {
    return apiClient.get('/api/me');
  },

  /**
   * Create a Stripe Checkout session for subscription signup
   * Endpoint: POST /api/stripe/create-checkout-session
   * 
   * @param {string} tier - "CORE" | "PRO" (NOTE: "ELITE" tier exists but not publicly available)
   * @returns {Promise} Response with { url: "https://checkout.stripe.com/..." }
   */
  createCheckoutSession(tier) {
    return apiClient.post('/api/stripe/create-checkout-session', { tier });
  },

  /**
   * Create a Stripe Billing Portal session for subscription management
   * Endpoint: POST /api/stripe/create-portal-session
   * 
   * Allows users to:
   * - Cancel subscription
   * - Update payment method
   * - View invoices
   * - Download receipts
   * 
   * @returns {Promise} Response with { url: "https://billing.stripe.com/..." }
   */
  createPortalSession() {
    return apiClient.post('/api/stripe/create-portal-session');
  }
};
